// The drag data type of an answer or photo dragged out of the "Daten aus
// Stundenzetteln" panel. Shared so the report's own drop zones
// (file_upload_controller.js) can tell such a drag from dropped files and leave it to
// the panel (timesheet_data_panel_controller.js).
export const TIMESHEET_DATA_TYPE = "application/x-bautask-timesheet-data"
